import { useMutation } from '@apollo/client';
import UPLOAD_CREDENTIALS from '../graphql/credentials/mutations';
import useNationalInvoiceProvider from './useNationalInvoiceProvider';

const useUploadCredentials = (source, email) => {
  const nationalInvoiceProvider = useNationalInvoiceProvider();

  const [uploadCredentials] = useMutation(UPLOAD_CREDENTIALS, {
    variables: {
      source,
      credentialProvider: nationalInvoiceProvider?.id,
      email,
    },
  });

  return { uploadCredentials };
};

export default useUploadCredentials;
